import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tab } from '../Tab';

import { MetaAuthenticated } from './MetaAuthenticated';
import { MetaOAuth } from './MetaOAuth';

import { useAuth } from '@/contexts/AuthContext';
import { META_OAUTH_QUERY_KEY } from '@/hooks/useMetaOAuth';

export function Meta() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Meta',
  });

  const [isConnected, setIsConnected] = useState(false);

  const queryClient = useQueryClient();

  const { user } = useAuth();

  function handleDisconnect() {
    setIsConnected(false);

    queryClient.removeQueries({
      queryKey: META_OAUTH_QUERY_KEY,
    });
  }

  useEffect(() => {
    if (user?.customer.meta_user_token) {
      setIsConnected(true);
    }
  }, [user]);

  return (
    <Tab
      title={t('title')}
      description={isConnected ? t('connected') : t('disconnected')}
    >
      {isConnected ? (
        <MetaAuthenticated
          customerBusinessAccountId={user?.customer.meta_business_id}
          onDisconnect={handleDisconnect}
        />
      ) : (
        <MetaOAuth />
      )}
    </Tab>
  );
}
